export default __webpack_public_path__ + "static/media/christ-university.8a66971c.jpg";